import { Flex } from "antd";
import { darken } from "polished";
import styled from "styled-components";

export const LinkContainer = styled(Flex)(({ theme }) => ({
  alignItems: "center",
  justifyContent: "center",
  height: 48,
  width: 48,
  overflow: "hidden",

  padding: theme.spacing,
  borderRadius: theme.borderRadius,
  backgroundColor: "#f0f0f0",
  fontSize: 32,
  transition: "all 0.3s ease-in-out",

  "&:hover": {
    backgroundColor: darken(0.02, "#f0f0f0"),
    color: theme.colorPrimary,
  },
}));
